module.exports = __webpack_public_path__ + "media/images/edit_white-0cd6972a446f6bad3a01483d60ca1ea9.svg";